import React, {Component} from "react";
import {
  Table,
  Button,
  Row,
  Col
}                         from "react-bootstrap";
import moment             from "moment";

import { IS_VALID }       from "utils";

export default class View extends Component {
  render () {
    let {
      NotificationHistory
    } = this.props;

    let {
      selectedData
    } = NotificationHistory;

    let GET_DATA = (key) => {
      let value = "";

       if (IS_VALID(selectedData) && IS_VALID(selectedData.get(key))) {
        if (key === "specificUsers" || key === "blacklistedUsers") {
          value = selectedData.get(key).join(", ");
        } else if (
          key === "pushDateTime" ||
          key === "dateApproved" ||
          key === "sendingStartDate" ||
          key === "sendingEndDate"
        ) {
          value = moment(selectedData.get("pushDateTime")).format("MMM DD, YYYY hh:mm A");
        } else if (key === "User" || key === "Sender") {
          value = IS_VALID(selectedData.get(key).get("name")) ? selectedData.get(key).get("name") : selectedData.get(key).get("username");
        } else if (key === "cardTypes") {
          value = selectedData.get(key).join(", ");
        } else {
          value = selectedData.get(key);
        }
      }

      return value;
    };

    let data = [
      {
        label: "Send Mode",
        value: GET_DATA("sendMode")
      },
      {
        label: "User Type",
        value: GET_DATA("userType")
      },
      {
        label: "Card Holder Type",
        value: GET_DATA("cardTypes")
      },
      {
        label: "Device Type",
        value: GET_DATA("device")
      },
      {
        label: "Screen",
        value: GET_DATA("screen")
      },
      {
        label: "Browser",
        value: GET_DATA("browser")
      },
      {
        label: "Specific Users",
        value: GET_DATA("specificUsers")
      },
      {
        label: "Excluded Users",
        value: GET_DATA("blacklistedUsers")
      }
    ];

    let data2 = [
      {
        label: "Subject",
        value: <p>{GET_DATA("subject")}</p>
      },
      {
        label: "URL",
        value: GET_DATA("url")
      },
      {
        label: "Message",
        value: <p>{GET_DATA("message")}</p>
      },
      {
        label: "Send Type",
        value: GET_DATA("sendType")
      },
      {
        label: "Schedule",
        value: GET_DATA("pushDateTime")
      },
      {
        label: "User",
        value: GET_DATA("User")
      }
    ];

    let data3 = [
      {
        label: "Status",
        value: GET_DATA("status")
      },
      {
        label: "Member Token Count",
        value: GET_DATA("memberTokenCount")
      },
      {
        label: "Device Token Count",
        value: GET_DATA("deviceTokenCount")
      },
      {
        label: "Sender",
        value: GET_DATA("Sender")
      },
      {
        label: "Date Approved",
        value: GET_DATA("dateApproved")
      },
      {
        label: "Sending Start Date",
        value: GET_DATA("sendingStartDate")
      },
      {
        label: "Sending End Date",
        value: GET_DATA("sendingEndDate")
      }
    ];

    return (
      <div>
        <Table
          bordered
          responsive
          style={{
            tableLayout: "fixed"
          }}
          >
          <tbody>
            {data.map((item, index) => (
              <tr id={index}>
                <td>
                  <b>{item.label}</b>
                </td>
                <td>{item.value}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Table
          bordered
          responsive
          style={{
            tableLayout: "fixed"
          }}
          >
          <tbody>
            {data2.map((item, index) => (
              <tr id={index}>
                <td>
                  <b>{item.label}</b>
                </td>
                <td>{item.value}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Table
          bordered
          responsive
          style={{
            tableLayout: "fixed"
          }}
          >
          <tbody>
            {data3.map((item, index) => (
              <tr id={index}>
                <td>
                  <b>{item.label}</b>
                </td>
                <td>{item.value}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/NotificationHistory/FormContainer/View.js